module.exports = __webpack_public_path__ + "img/19-1.9f2ff2da.png";